var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerEngagement({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #00b538;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.56,7.07l2.69-.04c-5.6-4.45-13.45-4.73-19.36-.84S2.21,17.31,3.98,24.3c.34,1.33.96,2.54,1.5,3.81.35.82,1.93,2.67,2.87,3.74.21.24.18.75.02.97s-.84.4-1.05.19C1.17,27.08.08,17.56,4.58,10.4,10.47,1.05,23.13-1,31.61,6.04l-.03-2.8c0-.44.37-.83.8-.86s.86.36.86.87v4.53c0,.49-.39.89-.86.89h-4.62c-.39,0-.8-.37-.84-.67-.05-.36.28-.92.64-.92Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.27,21.92l.03,2.13c0,.54-.24.92-.77.97-.38.03-.81-.36-.82-.84l-.03-2.31h-3.29c-.23.01-.7-.27-.8-.48s0-.71.17-.93l4.1-5.08c.17-.22.57-.38.83-.35s.65.48.65.78l-.02,4.47,1.12.13c.2.02.37.46.38.64s-.16.66-.35.69l-1.19.2ZM17.72,20.23l-.07-2.1-1.63,2.11h1.7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.67,24.55c-.6,0-.97-.43-.9-.99.11-.75.53-1.51,1.16-1.97l2.76-2.03c.63-.46.84-1.26.51-1.92-.49-.47-1.06-.6-1.86-.49-1.24.61-1.17,1.89-2.23,1.26-.28-.17-.42-.73-.22-1.1.79-1.4,2.32-2.12,3.87-1.74.9.22,1.64.88,1.92,1.5.46,1.01.38,2.02-.21,2.86-1,1.45-2.41,1.76-3.59,2.97h3.23c.44,0,.85.35.87.76.03.47-.36.9-.89.9h-4.44Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.09,23.96c-.22.5-.71.68-1.11.49s-.57-.67-.39-1.1l2.61-6.24h-3c-.39,0-.78-.42-.8-.73-.03-.44.3-.89.82-.89h4.2c.16,0,.53.16.62.29.11.15.14.55.13.79l-3.08,7.4Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.86,24.7c-.1.49-.5.77-.84.78-.28,0-.88-.46-.81-.82l1.89-9.5c.09-.43.6-.67.93-.6.38.08.74.51.66.96l-1.83,9.19Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.09,20.07c.19,1.32.11,2.66-.8,2.82-.25.04-.85-.29-.84-.56l.1-2.05c.01-.23.39-.51.6-.57.27-.08.89.04.94.36Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.65,37.31c-.41.15-.95-.04-1.1-.37-.22-.49.05-.98.52-1.15l1.5-.56c.44-.16.95.13,1.04.55.1.47-.15.85-.61,1.02l-1.35.51Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.33,11.91c.17.26.09.81-.06,1.03-.19.27-.84.42-1.1.14-.39-.43-.57-.93-.82-1.42-.14-.28-.35-.75-.22-1.09.1-.27.64-.38,1.09-.37l1.1,1.71Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.65,27.33c-.11.29-.8.41-1.04.3-.31-.15-.55-.68-.42-1.02l.59-1.52c.15-.4.59-.62.98-.53.44.09.71.64.54,1.09l-.65,1.69Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.93,37.93l-1.49-.31c-.45-.09-.8-.49-.74-.93.07-.48.55-.8,1.05-.68l1.56.36c.41.09.69.58.61.95-.09.42-.56.71-.99.62Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.1,38.09c-.55-.09-.58-1.37-.07-1.43l1.9-.23c.26-.03.71.25.83.48.15.29.04.97-.29,1.05-.78.19-1.52.26-2.37.12Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.73,34.87c.29.14.55.72.48,1.01-.06.27-.64.67-.91.56-1.27-.49-2.38-1.02-2.11-1.9.08-.26.67-.57.93-.45l1.62.78Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.9,31.74c-.15.2-.77.11-.99-.05-.18-.13-.44-.55-.36-.77l1.12-1.58c.26-.37.8-.49,1.17-.23.35.24.44.8.13,1.21l-1.08,1.43Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.96,17.21c.05.25-.48.61-.7.64-.25.04-.8-.15-.86-.43l-.41-1.69c-.1-.41.19-.88.56-.99.51-.15.96.16,1.06.7l.34,1.75Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.9,35.2c-.31.18-.91-.26-.96-.54-.06-.37.16-.8.47-1.02l1.12-.81c.31-.22.76-.26,1.01-.07.3.23.43.88.19,1.1-.59.55-1.03.89-1.83,1.34Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerEngagement);
export default __webpack_public_path__ + "static/media/customer-engagement.54c8388ad9a329ebe537f0fc926b5676.svg";
export { ForwardRef as ReactComponent };